<p-datepicker
  [ngModel]="
    selectedRange ? [selectedRange.getStart(), selectedRange.getEnd()] : null
  "
  (ngModelChange)="onDatePickerChange($event)"
  (onClose)="onDatePickerClose()"
  dateFormat="dd.mm.yy"
  selectionMode="range"
  firstDayOfWeek="1"
  [readonlyInput]="true"
  [showButtonBar]="showButtonBar()"
  [showIcon]="showIcon()"
  [showTime]="showTime()"
  [disabled]="disabled()"
  hourFormat="24"
  [hideOnDateTimeSelect]="!showTime()"
  [placeholder]="placeholder()"
  [panelStyleClass]="showTime() ? 'app-date-picker-panel--side-time' : ''"
>
  @if (showTime()) {
    <ng-template #footer>
      <div class="time-side">
        <div class="time-side__field">
          <div class="time-side__header">
            <p-checkbox
              [ngModel]="startTimeEnabled"
              (ngModelChange)="onStartTimeEnabledChange($event)"
              [binary]="true"
              inputId="date-picker-start-time"
              data-cy="date-picker-time-from-enabled"
            ></p-checkbox>
            <label class="time-side__label" for="date-picker-start-time"
              >Start</label
            >
          </div>
          <div
            class="hour-stepper"
            [class.hour-stepper--disabled]="!startTimeEnabled"
          >
            <button
              type="button"
              class="hour-stepper__button"
              aria-label="Next hour"
              [disabled]="!startTimeEnabled"
              (click)="incrementStartHour()"
            >
              <i class="pi pi-chevron-up"></i>
            </button>
            <span class="hour-stepper__value" data-cy="date-picker-time-from">{{
              formattedStartHour
            }}</span>
            <button
              type="button"
              class="hour-stepper__button"
              aria-label="Previous hour"
              [disabled]="!startTimeEnabled"
              (click)="decrementStartHour()"
            >
              <i class="pi pi-chevron-down"></i>
            </button>
          </div>
        </div>
        <div class="time-side__field">
          <div class="time-side__header">
            <p-checkbox
              [ngModel]="endTimeEnabled"
              (ngModelChange)="onEndTimeEnabledChange($event)"
              [binary]="true"
              inputId="date-picker-end-time"
              data-cy="date-picker-time-to-enabled"
            ></p-checkbox>
            <label class="time-side__label" for="date-picker-end-time"
              >End</label
            >
          </div>
          <div
            class="hour-stepper"
            [class.hour-stepper--disabled]="!endTimeEnabled"
          >
            <button
              type="button"
              class="hour-stepper__button"
              aria-label="Next hour"
              [disabled]="!endTimeEnabled"
              (click)="incrementEndHour()"
            >
              <i class="pi pi-chevron-up"></i>
            </button>
            <span class="hour-stepper__value" data-cy="date-picker-time-to">{{
              formattedEndHour
            }}</span>
            <button
              type="button"
              class="hour-stepper__button"
              aria-label="Previous hour"
              [disabled]="!endTimeEnabled"
              (click)="decrementEndHour()"
            >
              <i class="pi pi-chevron-down"></i>
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  }
  <ng-template #buttonbar>
    <div class="buttons">
      <button
        pButton
        class="flex-1"
        size="small"
        severity="secondary"
        (click)="selectThisWeek()"
      >
        This Week
      </button>
      <button
        pButton
        class="flex-1"
        size="small"
        severity="secondary"
        (click)="selectThisMonth()"
      >
        This Month
      </button>
      <button
        pButton
        class="flex-1"
        size="small"
        severity="secondary"
        (click)="selectLastWeek()"
      >
        Last Week
      </button>
      <button
        pButton
        class="flex-1"
        size="small"
        severity="secondary"
        (click)="selectLastMonth()"
      >
        Last Month
      </button>
    </div>
  </ng-template>
</p-datepicker>
